export default __webpack_public_path__ + "static/media/img_4.e811998d.jpg";